<template>
  <div class="holidayBook_overApplyNum flex-col flex-al-center">
    <img
      class="icon"
      src="https://img01.yzcdn.cn/upload_files/2022/01/05/FlSmdNvbsoOOCP3lkK9SIf54dOtF.png"
    />
    <span class="title1">尊敬的平台用户</span>
    <span class="title2"
      >本学期申请次数已用完<br />
      无法再继续申请</span
    >
    <div class="back flex-center" @click="$router.replace('/')">返回答案核对</div>
  </div>
</template>

<script>
/*
 * By Suxue
 * 2022/1/5
 */
export default {
  name: 'OverApplyNum',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.holidayBook_overApplyNum {
  min-height: 100vh;
  background: #ffffff;
  overflow: auto;
  .icon {
    margin-top: 72px;
    width: 166px;
  }
  .title1 {
    margin-top: 28px;
    font-size: 14px;
    color: #020202;
    font-weight: 600;
  }
  .title2 {
    margin-top: 8px;
    text-align: center;
    width: 227px;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
  .back {
    margin-top: 114px;
    width: 264px;
    height: 50px;
    background: linear-gradient(90deg, #fd735d 0.16%, #ff423c 100.16%);
    border-radius: 50px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
